import type { PropsWithChildren } from "react";
import { Typography } from "@circle-react-shared/uikit/Typography";

export interface ListFieldItemHeaderProps {
  title: string;
}

export const ListFieldItemHeader = ({
  title,
  children,
}: PropsWithChildren<ListFieldItemHeaderProps>) => (
  <div className="flex items-center justify-between">
    <Typography.LabelSm weight="semibold">{title}</Typography.LabelSm>
    {children}
  </div>
);
